import { render, staticRenderFns } from "./form-tag-association.vue?vue&type=template&id=1b5fc95c&scoped=true"
import script from "./form-tag-association.vue?vue&type=script&lang=js"
export * from "./form-tag-association.vue?vue&type=script&lang=js"
import style0 from "./form-tag-association.vue?vue&type=style&index=0&id=1b5fc95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5fc95c",
  null
  
)

export default component.exports